import { auth } from '../firebase';

// Socket.IO handshake auth: sends the signed-in teacher's Firebase ID token (refreshed on each reconnect).
// The backend only lets the owner of a tutorial join its live-answers room.
export const socketAuth = (cb) => {
  const user = auth.currentUser;
  if (!user) { cb({}); return; }
  user.getIdToken().then((token) => cb({ token })).catch(() => cb({}));
};
